import styled from 'styled-components';
import { StyledRowContent } from '../ProjectProgression.style';
import { StyledInsightItem } from './InsightItem/InsightItem.style';

export const StyledInsightsList = styled(StyledRowContent)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;

  & ${StyledInsightItem} {
    padding-bottom: 1.2rem;
  }
  & > main {
    width: 100%;
    overflow-y: scroll;
    height: 34rem;
  }
`;

export const StyledInsights = styled.div``;
